
import { Component, Vue } from 'vue-property-decorator';
import { handleStoreIntegrationCallback } from '../../helpers/eCommerce';
import { AddStorePayload, PlatformType } from '../../types';

@Component
export default class CallbackShopify extends Vue {
  get code(): string | null {
    return this.$route.query.code as string;
  }

  get hmac(): string | null {
    return this.$route.query.hmac as string;
  }

  get shop(): string | null {
    return this.$route.query.shop as string;
  }

  get timestamp(): string | null {
    return this.$route.query.timestamp as string;
  }

  get state(): string | null {
    return this.$route.query.state as string;
  }

  async mounted() {
    if (!this.code || !this.hmac || !this.shop || !this.timestamp || !this.state) return;

    const payload: AddStorePayload = {
      platformType: PlatformType.Shopify,
      inputFields: [
        { fieldId: 'StoreUrl', value: this.shop },
        { fieldId: 'Code', value: this.code },
        { fieldId: 'Nonce', value: this.state },
        { fieldId: 'Hmac', value: this.hmac },
        { fieldId: 'Timestamp', value: this.timestamp },
      ],
    };

    await handleStoreIntegrationCallback(payload);
  }
}
